import { render } from "./TabContentItem.vue?vue&type=template&id=02c9757e"
import script from "./TabContentItem.vue?vue&type=script&lang=js"
export * from "./TabContentItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__